export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-8-ae14696cadad5987460fa00c385077e0.jpg";